"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByTime = exports.sortByAlpha = void 0;
const sortByAlpha = (a, b, property = 'name') => {
    const x = (typeof a === 'object' ? a[property] : a).toLowerCase();
    const y = (typeof b === 'object' ? b[property] : b).toLowerCase();
    return x.localeCompare(y);
};
exports.sortByAlpha = sortByAlpha;
const sortByTime = (a, b, property = 'time') => {
    const x = typeof a === 'object' ? a[property] : a;
    const y = typeof b === 'object' ? b[property] : b;
    return new Date(`1970/01/01 ${x}`).valueOf() - new Date(`1970/01/01 ${y}`).valueOf();
};
exports.sortByTime = sortByTime;
//# sourceMappingURL=sort.js.map